import { injectable, inject } from 'inversify';
import HttpClient from '../../../http';
import {
  ReviewsServiceInterface,
  UpdateReviewRequest,
  UpdateReviewResponse,
  GetPendingReviewResponse,
  GetPendingReviewRequest,
} from './ReviewsService.types';
import { backendUrl } from 'src/config';

@injectable()
class ReviewsService implements ReviewsServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  public updateReview({ order_pk, accessToken, ...data }: UpdateReviewRequest) {
    return this.client
      .getClient()
      .post<UpdateReviewResponse>(`/nps/orders/`, data, {
        baseURL: backendUrl,
        params: { order_pk },
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });
  }

  public getPendingReview({ accessToken }: GetPendingReviewRequest) {
    return this.client
      .getClient()
      .get<GetPendingReviewResponse>('/nps/orders/pending/', {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      });
  }
}

export default ReviewsService;
